/* ============================================================
   NAVISHKA — Color dot painter for facet/filter panel
   Add this to assets/facets.js  OR  paste into theme.liquid
   inside a <script> tag after DOMContentLoaded
   ============================================================ */

var NCS_FILTER_COLORS = {
  /* ── Navishka Brand Palette ── */
  'dusty-rose'     : '#D56F74',
  'sand-beige'     : '#CBAC8F',
  'terracotta'     : '#CD7B5A',
  'khaki'          : '#C4AC6B',
  'slate-blue'     : '#818FB5',
  'olive'          : '#C1BF5F',
  'denim'          : '#777CA7',
  'blush-pink'     : '#E4ACC2',
  'duck-egg'       : '#7EA3AC',
  'steel-blue'     : '#757D9E',
  'mauve'          : '#BE6EAA',
  'warm-taupe'     : '#A78670',
  'light-grey'     : '#DAD5D7',
  'cream'          : '#DBCEC4',
  'stone'          : '#C2ADA0',
  'charcoal'       : '#645E5C',

  /* ── Basics ── */
  'white'          : '#FFFFFF',
  'off-white'      : '#F5F0E8',
  'ivory'          : '#FFFFF0',
  'black'          : '#1A1A1A',
  'grey'           : '#9E9E9E',
  'gray'           : '#9E9E9E',
  'silver'         : '#C0C0C0',

  /* ── Blues ── */
  'blue'           : '#2563EB',
  'navy'           : '#1A1F6E',
  'navy-blue'      : '#1A1F6E',
  'royal-blue'     : '#4169E1',
  'sky-blue'       : '#87CEEB',
  'ice-blue'       : '#B0D9F0',
  'light-blue'     : '#ADD8E6',
  'dark-blue'      : '#00008B',
  'cobalt'         : '#0047AB',
  'teal'           : '#008080',
  'turquoise'      : '#40E0D0',
  'aqua'           : '#00FFFF',
  'peacock-blue'   : '#005F6A',
  'prussian-blue'  : '#003153',
  'powder-blue'    : '#B0C4DE',
  'midnight-blue'  : '#191970',

  /* ── Greens ── */
  'green'          : '#16A34A',
  'dark-green'     : '#006400',
  'light-green'    : '#90EE90',
  'mint'           : '#98FF98',
  'mint-green'     : '#98FF98',
  'bottle-green'   : '#006A4E',
  'forest-green'   : '#228B22',
  'jade'           : '#00A86B',
  'emerald'        : '#50C878',
  'parrot-green'   : '#4CBB17',
  'sage'           : '#8FBC8F',
  'pista'          : '#93C572',
  'mehendi'        : '#4B6043',

  /* ── Reds / Pinks ── */
  'red'            : '#DC2626',
  'dark-red'       : '#8B0000',
  'crimson'        : '#DC143C',
  'maroon'         : '#800000',
  'pink'           : '#FF69B4',
  'hot-pink'       : '#FF1493',
  'light-pink'     : '#FFB6C1',
  'baby-pink'      : '#F4C2C2',
  'rose'           : '#FF007F',
  'peach'          : '#FFCBA4',
  'blush'          : '#DE5D83',
  'coral'          : '#FF6B6B',
  'salmon'         : '#FA8072',
  'magenta'        : '#FF00FF',
  'fuchsia'        : '#FF00FF',
  'rani-pink'      : '#E7508A',

  /* ── Purples ── */
  'purple'         : '#7C3AED',
  'violet'         : '#8B00FF',
  'lavender'       : '#E6E6FA',
  'lilac'          : '#C8A2C8',
  'plum'           : '#DDA0DD',
  'wine'           : '#722F37',
  'burgundy'       : '#800020',
  'grape'          : '#6F2DA8',
  'indigo'         : '#4B0082',
  'orchid'         : '#DA70D6',

  /* ── Yellows / Browns ── */
  'yellow'         : '#FCD34D',
  'lemon'          : '#FFF44F',
  'mustard'        : '#FFDB58',
  'orange'         : '#F97316',
  'mango'          : '#FDBE02',
  'amber'          : '#FFC107',
  'tan'            : '#D2B48C',
  'beige'          : '#F5F5DC',
  'nude'           : '#E3BC9A',
  'caramel'        : '#C68642',
  'brown'          : '#795548',
  'chocolate'      : '#7B3F00',
  'rust'           : '#B7410E',
  'copper'         : '#B87333',
  'gold'           : '#C9A84C',
  'rose-gold'      : '#B76E79',
  'bronze'         : '#CD7F32',

  /* ── Multi ── */
  'multicolor'     : 'linear-gradient(135deg,#FF6B6B,#FFD700,#7C3AED,#16A34A)',
  'multi'          : 'linear-gradient(135deg,#FF6B6B,#FFD700,#7C3AED,#16A34A)',
  'multi-color'    : 'linear-gradient(135deg,#FF6B6B,#FFD700,#7C3AED,#16A34A)',
  'mix'            : 'linear-gradient(135deg,#FF6B6B,#FFD700,#7C3AED,#16A34A)',
  'rainbow'        : 'linear-gradient(135deg,#FF0000,#FF7700,#FFFF00,#00CC00,#0000FF,#8B00FF)',

  /* ── Jewellery-specific combos ── */
  'blue-beads'     : '#5B7FBD',
  'green-beads'    : '#2E8B57',
  'red-beads'      : '#C0392B',
  'pink-beads'     : '#FF69B4',
  'white-beads'    : '#F0F0F0',
  'green-ruby'     : 'linear-gradient(135deg,#2E8B57 50%,#C0392B 50%)',
};

function ncsNormalizeKey(str) {
  return (str || '').toLowerCase().trim()
    .replace(/\s*&\s*/g, '-and-')
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9\-]/g, '');
}

function ncsFindColor(rawLabel) {
  var key = ncsNormalizeKey(rawLabel);
  if (NCS_FILTER_COLORS[key]) return NCS_FILTER_COLORS[key];
  /* partial match: label contains a known key */
  var keys = Object.keys(NCS_FILTER_COLORS);
  for (var i = 0; i < keys.length; i++) {
    if (key.indexOf(keys[i]) !== -1 || keys[i].indexOf(key) !== -1) {
      return NCS_FILTER_COLORS[keys[i]];
    }
  }
  return null;
}

function ncsInjectFilterDots() {
  /* Dawn renders filter labels in .facet-checkbox elements.
     The text label sits in a <span> or directly in the label.
     We inject a colored circle BEFORE the text. */

  /* Target the COLOR filter section only — look for heading "COLOR" */
  document.querySelectorAll('.facets__display, .facets__list-wrapper').forEach(function(section) {

    /* Check if this section is a color filter */
    var heading = section.closest('details')
      ? section.closest('details').querySelector('.facets__heading, .facets__summary span')
      : null;
    var headingText = heading ? heading.textContent.trim().toUpperCase() : '';

    /* Only paint dots for COLOR filter sections */
    if (!headingText || headingText !== 'COLOR') return;

    section.querySelectorAll('.facet-checkbox, label.facet-checkbox').forEach(function(label) {

      /* Skip if already painted */
      if (label.querySelector('.ncs-filter-dot')) return;

      /* Get the text of this filter option */
      var textEl = label.querySelector('.facet-checkbox__label, span:not(.facets__count):not(.visually-hidden)')
                || label;
      var rawText = '';
      /* Walk text nodes only to avoid grabbing count numbers */
      textEl.childNodes.forEach(function(node) {
        if (node.nodeType === Node.TEXT_NODE) rawText += node.textContent;
      });
      if (!rawText.trim()) rawText = textEl.textContent || '';
      rawText = rawText.replace(/\(\d+\)/g, '').trim();

      var fill = ncsFindColor(rawText);
      if (!fill) return; /* no match — don't show a dot */

      /* Create the dot */
      var dot = document.createElement('span');
      dot.className = 'ncs-filter-dot';
      dot.title = rawText;
      if (fill.startsWith('linear-gradient')) {
        dot.style.background = fill;
      } else {
        dot.style.backgroundColor = fill;
        /* Add dark border for very light colors */
        var lightColors = ['#FFFFFF','#F5F0E8','#FFFFF0','#F5F5DC','#E6E6FA','#F0F0F0','#DBCEC4','#DAD5D7'];
        if (lightColors.indexOf(fill.toUpperCase()) !== -1 || lightColors.indexOf(fill) !== -1) {
          dot.style.borderColor = '#bbb';
        } else {
          dot.style.borderColor = fill;
        }
      }

      /* Insert dot as first child of label */
      label.insertBefore(dot, label.firstChild);
    });
  });
}

/* Run on load + after filter AJAX updates */
document.addEventListener('DOMContentLoaded', function() {
  ncsInjectFilterDots();
  setTimeout(ncsInjectFilterDots, 500);
  setTimeout(ncsInjectFilterDots, 1200);
});

/* Re-run after Dawn's facet AJAX reloads the filter panel */
document.addEventListener('facets:filter:active', ncsInjectFilterDots);
document.addEventListener('facets:updated', ncsInjectFilterDots);

/* MutationObserver — catches filter panel opening (details[open]) */
var facetsObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(m) {
    if (m.type === 'attributes' && m.attributeName === 'open') {
      setTimeout(ncsInjectFilterDots, 50);
    }
    if (m.type === 'childList') {
      setTimeout(ncsInjectFilterDots, 100);
    }
  });
});
document.querySelectorAll('details.js-filter, .facets__display').forEach(function(el) {
  facetsObserver.observe(el, { attributes: true, childList: true, subtree: true });
});